import React, { useState } from "react";

interface FormData {
  name: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
}

const ContactForm = () => {
  const [formData, setFormData] = useState<FormData>({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState<Partial<FormData>>({});
  const [submitted, setSubmitted] = useState(false);

  // VALIDATION
  const validate = () => {
    const newErrors: Partial<FormData> = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email address";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    }

    if (!formData.subject.trim()) {
      newErrors.subject = "Subject is required";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // HANDLE INPUT CHANGE
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    // Remove error while typing
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  // SUBMIT
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!validate()) return;

    // MAIL BODY
    const mailSubject = encodeURIComponent(
      `GWCS Contact Request - ${formData.subject}`
    );

    const mailBody = encodeURIComponent(`
Name: ${formData.name}

Email: ${formData.email}

Phone: ${formData.phone}

Subject: ${formData.subject}

Message:
${formData.message}
    `);

    // OPEN MAIL CLIENT
    window.location.href = `mailto:ashok@gwcs.in?subject=${mailSubject}&body=${mailBody}`;

    setSubmitted(true);

    // RESET FORM
    setFormData({
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
    });
  };

  return (
    <div className="contact-form">

      {submitted && (
        <div className="alert alert-success mb-4">
          Your message has been prepared successfully.
        </div>
      )}

      <form className="row" onSubmit={handleSubmit}>

        {/* NAME */}
        <div className="col-md-6 mb-3">
          <input
            type="text"
            name="name"
            className="form-control"
            placeholder="Your Name*"
            value={formData.name}
            onChange={handleChange}
          />

          {errors.name && (
            <small className="text-danger">
              {errors.name}
            </small>
          )}
        </div>

        {/* EMAIL */}
        <div className="col-md-6 mb-3">
          <input
            type="email"
            name="email"
            className="form-control"
            placeholder="Email Address*"
            value={formData.email}
            onChange={handleChange}
          />

          {errors.email && (
            <small className="text-danger">
              {errors.email}
            </small>
          )}
        </div>

        {/* PHONE */}
        <div className="col-md-6 mb-3">
          <input
            type="text"
            name="phone"
            className="form-control"
            placeholder="Phone Number*"
            value={formData.phone}
            onChange={handleChange}
          />

          {errors.phone && (
            <small className="text-danger">
              {errors.phone}
            </small>
          )}
        </div>

        {/* SUBJECT */}
        <div className="col-md-6 mb-3">
          <input
            type="text"
            name="subject"
            className="form-control"
            placeholder="Subject*"
            value={formData.subject}
            onChange={handleChange}
          />

          {errors.subject && (
            <small className="text-danger">
              {errors.subject}
            </small>
          )}
        </div>

        {/* MESSAGE */}
        <div className="col-md-12 mb-3">
          <textarea
            name="message"
            rows={5}
            className="form-control"
            placeholder="Please describe your requirements..."
            value={formData.message}
            onChange={handleChange}
          ></textarea>

          {errors.message && (
            <small className="text-danger">
              {errors.message}
            </small>
          )}
        </div>

        {/* BUTTON */}
        <div className="col-md-12">
          <button
            type="submit"
            className="btn btn-primary px-4 py-2"
          >
            Send Message
          </button>
        </div>

      </form>
    </div>
  );
};

export default ContactForm;